import React from "react"
import styled from "styled-components"
import { fontSize, fontWeight, colors } from "buoy-theme"
import { Heading } from "./Card"
import { STATIC_URL } from "../../common/constants"
import Text from "../../common/components/Text"
import Synopsis from "./Synopsis"
import SelfTreatment from "./SelfTreatment"
import ExpandableSection from "./ExpandableSection"
import TriageStatement from "./TriageStatement"
import { care, newTitles } from "../triageCopy"
import RecommendationCard from "../../common/components/RecommendationCard"

const DiagnosisContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
`

const CounterText = styled(Text)`
  ${fontSize("bodySmall")};
  color: ${colors.neutralDark};
  font-weight: ${fontWeight.regular};
  width: 100%;
`

const getExcerpt = diagnosis => {
  let excerpt = diagnosis.test_req
    ? diagnosis.test_req.description
    : diagnosis.overview
  excerpt = excerpt.length > 100 ? `${excerpt.substr(0, 80)}...` : excerpt
  return excerpt
}

const Diagnosis = ({
  diagnosis,
  index,
  total,
  recommendationSection,
  showZip,
  brand,
  results,
  setDiagnosisHelpfulness,
  initPayment,
  initIntellivisit,
}) => {
  const excerpt = getExcerpt(diagnosis)
  return (
    <DiagnosisContainer first={index === 0}>
      <CounterText>
        {diagnosis.eyebrow || `Match ${index + 1} of ${total}`}
      </CounterText>
      <Heading>{diagnosis.diagnosis}</Heading>
      <ExpandableSection
        expandable={excerpt.endsWith("...")}
        excerpt={excerpt}
        index={index}
        type="dx"
      >
        <Synopsis diagnosis={diagnosis} />
      </ExpandableSection>
      {diagnosis.advice_content &&
      diagnosis.advice_content.constructor === Object &&
      Object.keys(diagnosis.advice_content).length > 0 ? (
        <SelfTreatment
          label="care"
          header={diagnosis.triage}
          diagnosis={diagnosis}
          note={care[diagnosis.acuity]}
          index={index}
          selfCare={diagnosis.advice_content}
          setDiagnosisHelpfulness={setDiagnosisHelpfulness}
        />
      ) : (
        <ExpandableSection
          showPreview={false}
          label="care"
          header={diagnosis.triage}
          note={care[diagnosis.acuity]}
          expandLink={
            results.recommendation
              ? results.recommendation.explanation.label
              : newTitles[diagnosis.acuity]
          }
          index={index}
          type="care"
        >
          <TriageStatement
            results={results}
            recommendationSection={
              (recommendationSection && recommendationSection.length > 0) ||
              showZip
            }
            {...diagnosis}
          />
        </ExpandableSection>
      )}
      {recommendationSection &&
        Object.keys(recommendationSection).length > 0 &&
        renderRecommendationSection(
          recommendationSection,
          initPayment,
          diagnosis.token,
          initIntellivisit
        )}
    </DiagnosisContainer>
  )
}

const renderRecommendationSection = (
  recs,
  initPayment,
  diffToken,
  initIntellivisit
) => {
  const cardSec = []
  recs.forEach(rec => {
    cardSec.push(
      <RecommendationCard
        token={rec.token}
        key={rec.token}
        ctaText={rec.ctaText}
        ctaUrl={rec.ctaUrl}
        highlights={rec.highlights}
        infoList={rec.info}
        tags={rec.tags}
        headline={rec.headline}
        image={rec.image ? `${STATIC_URL}${rec.image}` : null}
        requirePayment={rec.requirePayment}
        requireProfile={rec.requireProfile}
        diffToken={diffToken}
        initPayment={initPayment}
        initIntellivisit={initIntellivisit}
        rec={rec}
        fullBorder
      />
    )
  })
  return cardSec
}

export { Diagnosis as default }



// WEBPACK FOOTER //
// ./assets/completion/components/Diagnosis.js